import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { serviceTypeModification, getSingleServiceType } from "./serviceTypeAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate,Link} from 'react-router-dom';
import { getAllServiceType } from "./serviceTypeAction";
import Swal from 'sweetalert2';
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';



const initialState = {
  id: "",
  servicetype: "",
  status: "",

}



const ModifyServiceType = () => {
  let navigate = useNavigate();
    const {id}=useParams();
  //console.log('modify'+id);
    const { stismloading, stmstatus, stmmessage  } = useSelector((state) => state.serviceTypiesList);

    const dispatch = useDispatch();
    
    const [serviceTypies, setServicetypies] = useState({
      id:"",
      servicetype:"",
      status:""
    });
    
    
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);
  
    
    const serviceTypeData = useSelector((state) => state.serviceTypiesList);
   


    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadServiceType(id);
      return;
    }

  });

  useEffect(() => {
    dispatch(getAllServiceType());
   
}, [dispatch,stmmessage]);

   useEffect(() => { 
    loadServiceType(id);
    setServicetypies({id:id,servicetype:"",status:""});
   
     }, []);

     
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadServiceType(id){
      console.log('load service'+ id)
      dispatch(getSingleServiceType(id));
      setServicetypies({id:id,servicetype:uData.service_type,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(serviceTypeData.stSDetails));
   console.log(uData.service_type);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
   
    setServicetypies({ ...serviceTypies, [name]: value });
   
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const { id, servicetype, status } = serviceTypies;
  
    // Check if any changes have been made
    if (servicetype === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/serviceTypeList');
      return;
    }
  
    dispatch(serviceTypeModification({ id, servicetype, status }));
    setModify(1);
    navigate('/serviceTypeList');
    Swal.fire('Service Type Updated Successfully!', '', 'success');
  };
  


  return (
    <>
      {/* <Container className="my-4 mx-4 container-xl ">

      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Modify Service</h4></Card.Header>
          <Card.Body>
          <Row>
              <Col>
      
              <Link to="/serviceTypeList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
              <br />
              </Col>
            </Row> */}
              <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Service Type</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/serviceTypeList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="servicetype" value={serviceTypies.servicetype ? serviceTypies.servicetype : uData.service_type} autoComplete='off' placeholder="Enter Service Type" {...register("servicetype", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                 {errors.servicetype && <p className='text-danger'> Service Type Name required</p>}
                </Form.Group>
               
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={serviceTypies.status ? serviceTypies.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
                Submit
              </Button>
              </div>
              {stismloading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default ModifyServiceType;